import Course from "@/api/models/Course";
// import cookiesHandler from "@/composables/cookiesHandler";
import UseStoreHandler from "@/composables/handlers/UseStoreHandler";
import utils from "@/composables/utils";
import CartService from "@/services/CartService";

export default {
    /**
     * Adds an item to cart
     * @param {State} state 
     * @param {CartHandler} cartHandler 
     */
    ADD_TO_CART(state, cartHandler) {
        const existingItem = state.items.find(i => i.uuid === cartHandler.item.uuid);

        if (!existingItem) {
            const courseData = {
                uuid: cartHandler.item.uuid,
                title: cartHandler.item.title,
                price: cartHandler.item.price,
                coursePhoto: cartHandler.item.coursePhoto
            };
            
            state.items.push(new Course(courseData));
            state.totalQuantity ++;
            state.totalPrice = state.totalPrice + parseFloat(cartHandler.item.price);

            if (cartHandler.persist) {

                if (UseStoreHandler.getAuthStore().isAuthenticated) {
                    CartService.addToCart(cartHandler.item.uuid);
                }

                // console.log('cart', cartHandler.item)
                // cookiesHandler.save(`myCart-${cartHandler.item.uuid}`, JSON.stringify(cartHandler.item));
                // console.log('did', {
                //     uuid: `myCart-${cartHandler.item.uuid}`,
                //     data: JSON.stringify(cartHandler.item),
                //     cookie: cookiesHandler.get(`myCart-${cartHandler.item.uuid}`)
                // })
            }
        }
    },

    /**
     * Removes a item from cart
     * @param {State} state 
     * @param {CartHandler} cartHandler 
     */
    REMOVE_FROM_CART(state, cartHandler) {
        const itemIndex = state.items.findIndex(i => i.uuid === cartHandler.item.uuid);
        if (itemIndex !== -1) {
            const item = state.items[itemIndex];
            state.totalQuantity -= item.quantity;
            state.totalPrice = state.totalPrice - parseFloat(item.price);

            state.items.splice(itemIndex, 1);

            if (cartHandler.persist)
                CartService.removeFromCart(item.uuid);
        }
    },

    /**
     * Updates cart item
     * @param {State} state 
     * @param {CartHandler} cartHandler 
     */
    UPDATE_ITEM_FROM_CART(state, cartHandler) {
        let existsInCart = false; 
        let updatedCart = [];
        for (let courseObj of state.items) {
            if (courseObj.uuid == cartHandler.item.uuid) {
                courseObj = utils.mergeObjects(courseObj, cartHandler.item);
                
                existsInCart = true;
            }

            updatedCart.push(courseObj);
        }

        if (existsInCart) {
            state.items = updatedCart;
        }

    },

    /**
     * Clean cart items
     * @param {State} state 
     * @param {CartHandler} cartHandler 
     */
    CLEAR_CART(state, cartHandler) {
        state.items = [];
        state.totalQuantity = 0;
        state.totalPrice = 0;

        if (cartHandler.persist)
            console.log('create method to clear cart')
    },
};